var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAligncenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1.3C0 0.858176 0.395047 0.5 0.882353 0.5H9.11765C9.60494 0.5 10 0.858176 10 1.3C10 1.74182 9.60494 2.1 9.11765 2.1H0.882353C0.395047 2.1 0 1.74182 0 1.3ZM0.882353 3.7C0.395047 3.7 0 4.05818 0 4.5C0 4.94182 0.395047 5.3 0.882353 5.3H5.58824C6.07554 5.3 6.47059 4.94182 6.47059 4.5C6.47059 4.05818 6.07554 3.7 5.58824 3.7H0.882353Z",
    fill: "#37352F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.882353 6.9C0.395047 6.9 0 7.25818 0 7.7C0 8.14182 0.395047 8.5 0.882353 8.5H9.11765C9.60494 8.5 10 8.14182 10 7.7C10 7.25818 9.60494 6.9 9.11765 6.9H0.882353Z",
    fill: "#37352F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAligncenter);
export default __webpack_public_path__ + "static/media/aligncenter.1e5a235b770e9dea879fe58a6d3fdbc9.svg";
export { ForwardRef as ReactComponent };